export const cx = (...args: unknown[]): string => args.join(" ");
